export const CANONICAL_ROUTES = {
  HOME: '/',
  EXPLORER: '/explorer',
  EXPLORER_BY_MANDALA: '/explorer/mandala/:mandalaNumber',
  EXPLORER_BY_MANDALA_BASE: '/explorer/mandala',
};

export const LEGACY_REDIRECT_ROUTES = [
  '/chat',
  '/meditation',
  '/dashboard',
  '/explorer-old',
  '/hymn/:mandala/:hymn',
];

